import React, { useEffect, useState, useRef } from 'react';
import { Button } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import fetch from '../Utils/fetch';
import ProductSlider from '../Products/ProductSlider';

const MobileCategorySection = ({ category, minProducts = 0, onInvalid }) => {
    const navigate = useNavigate();
    const [products, setProducts] = useState(category?.items || []);
    const [loading, setLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    const [isSkipped, setIsSkipped] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        }, { threshold: 0.1 });

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!isVisible) return;

        async function loadItems() {
            try {
                const res = await fetch.get('getProductsGroup', { group_code: category.item_group });
                const itemsList = res.list?.itemsarray || res.list || [];

                if (minProducts > 0 && itemsList.length <= minProducts) {
                    setIsSkipped(true);
                    if (onInvalid) onInvalid();
                    return;
                }

                setProducts(itemsList);
            } catch (err) {
                console.error('Failed to load category products:', err);
            } finally {
                setLoading(false);
            }
        }
        if (!category?.items) {
            loadItems();
        }
    }, [isVisible, category.item_group, minProducts, onInvalid]);

    if (isSkipped) return null;

    const final_category_format = {
        group_name: category?.group_name || category?.categoryName,
        item_group: category?.item_group || category?.categoryCode
    }

    return (
        <div className="sections" ref={sectionRef}>
            <section className="sectionheader">
                <div className="sectionheadertitle">{_.startCase(_.lowerCase(category?.group_name)) || _.startCase(_.lowerCase(category?.categoryName))}</div>
                <Button
                    color="secondary"
                    onClick={() => navigate(`/categoryitems`, { state: { category: final_category_format } })}
                    endIcon={<ChevronRight />}
                >
                    View All
                </Button>
            </section>

            {isVisible ? (
                <ProductSlider products={products} showquantity={true} />
            ) : (
                <div style={{ height: 200 }} />
            )}
        </div>
    );
};

export default MobileCategorySection;
